export enum WorkerFileVerificationStatusEnum {
  Pending = 1,
  Approved = 2,
  Rejected = 3,
}
